<template>
  <v-col style="position:absolute; top:0;left:0;" class="pa-0 ma-0">
    <LMap style="height: 90vh" ref="map" @click="changeAdminCursor" 
    :options="mapOptions" :center="center" :zoom="zoom" @zoomend="onZoomEnd" >
    
<div ref="vectorGrid" style="z-index: 1000;" /> 
<LTileLayer v-if="$vuetify.theme.dark"
        url="https://api.mapbox.com/styles/v1/pmcom/ck6m9eny40xsn1imy756u9tyw/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1IjoicG1jb20iLCJhIjoiY2lxajgxbHF3MDBjZWkwbWMza2pwYzFoayJ9.a1ywamqhc2BKAdxMdgcBpA" />
      <LTileLayer
        v-else
       url="https://api.mapbox.com/styles/v1/pmcom/ck6m9eny40xsn1imy756u9tyw/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1IjoicG1jb20iLCJhIjoiY2lxajgxbHF3MDBjZWkwbWMza2pwYzFoayJ9.a1ywamqhc2BKAdxMdgcBpA" />
      />
      <LTileLayer :options="{ zIndex: 100, bounds: maxBounds }" v-if="last_tile && !from && precipTile"
        :url="last_tile" />
      <LGeoJson/>
      
      <!-- Affichage des tronçons GeoJSON -->
      <template v-for="rail in userRails">
        <l-geo-json
          v-for="troncon in rail.troncons"
          :key="`troncon-${rail.id}-${troncon.id}`"
          :geojson="troncon.geojson"
          :options="geoJsonOptions"
        />
        <l-geo-json
          v-for="troncon in rail.troncons"
          :key="`troncon-${rail.id}-${troncon.id}-radius3`"
          :geojson="troncon.geojson_radius3"
          :options="{
            style: {
              color: 'yellow',      // couleur du contour
              weight: 2,         // épaisseur
              fillColor: 'yellow',  // couleur du remplissage (si polygone)
              fillOpacity: 0.05   // opacité du remplissage
            }
          }"
        />
        <l-geo-json
          v-for="troncon in rail.troncons"
          :key="`troncon-${rail.id}-${troncon.id}-radius2`"
          :geojson="troncon.geojson_radius2"
          :options="{
            style: {
              color: 'orange',      // couleur du contour
              weight: 2,         // épaisseur
              fillColor: 'orange',  // couleur du remplissage (si polygone)
              fillOpacity: 0.05   // opacité du remplissage
            }
          }"
        />
        <l-geo-json
          v-for="troncon in rail.troncons"
          :key="`troncon-${rail.id}-${troncon.id}-radius1`"
          :geojson="troncon.geojson_radius1"
          :options="{
            style: {
              color: 'red',      // couleur du contour
              weight: 2,         // épaisseur
              fillColor: 'red',  // couleur du remplissage (si polygone)
              fillOpacity: 0.05   // opacité du remplissage
            }
          }"
        />
        
      </template>
      
      <LRectangle :bounds="maxBounds" :color="$vuetify.theme.dark ? '#fff' : '#000'" :weight="1" :fill="false" />
      
      <LCircle v-if="targetPos" :color="targetColor" :radius="targetRadius || 500" :lat-lng="targetPos" />

      <!--<LCircle color="red" v-if="user.id_user == 3050 || user.id_user == 2520"
        :lat-lng="[admin.target.lat, admin.target.lon]" :radius="30 * 1000" />-->

      <template v-for="(user_sub, i) in user_subs">
        <LFeatureGroup :key="i">
          <LMarker :lat-lng="[user_sub.lat, user_sub.lon]">
            <LIcon iconUrl="/storm-marker.svg" />
          </LMarker>
          <LCircle color="red" :lat-lng="[user_sub.lat, user_sub.lon]" :radius="user_sub.radius1 * 1000" />
          <LCircle color="orange" :lat-lng="[user_sub.lat, user_sub.lon]" :radius="user_sub.radius2 * 1000" />
          <LCircle color="yellow" :lat-lng="[user_sub.lat, user_sub.lon]" :radius="user_sub.radius3 * 1000" />
        </LFeatureGroup>
      </template>
     
      <LControl position="topright">
        <v-card>
          <v-card-text v-if="lastimpact && !loading">
            <v-col class="text-right py-0">
              <h3>
                <v-btn icon @click="
                  $refs.map.mapObject.setView(
                    [lastimpact.lat, lastimpact.lon],
                    8
                  )
                  "><v-icon color="red">mdi-lightning-bolt</v-icon></v-btn>
                {{ $t("stormwatch.map.LastImpacts") }}
              </h3>
            </v-col>
            <v-col class="text-right py-0">
              <b>{{ $t("stormwatch.map.At") }}
                {{ moment(lastimpact.time * 1000).format("DD/MM HH:mm") }}</b>
              <v-switch dense inset x-small v-if="false" v-model="tracking" label="Suivre" />
            </v-col>
          </v-card-text>
          <v-card-text v-else>
            <v-progress-circular indeterminate v-if="loading" />
          </v-card-text>
        </v-card>
      </LControl>
      <!-- <LControl position="bottomright">
        <v-switch inset v-model="$vuetify.theme.dark" :label="$t('stormwatch.map.Light/Dark')" />
      </LControl> -->

      <LControl position="bottomleft" style="padding-bottom:20px">

        <v-col style="z-index:100000;">
          <v-btn icon v-if="!isParamOpen" @click="isParamOpen = !isParamOpen">
            <v-icon v-if="!isParamOpen">mdi-cog</v-icon>
          </v-btn>
          <v-card v-if="isParamOpen">
            <v-btn icon @click="isParamOpen = !isParamOpen">
              <v-icon v-if="isParamOpen">mdi-minus</v-icon>
            </v-btn>
            <v-card-text>
              <v-text-field :disabled="liveMode || !user.features.find(map => map == 'stormwatch')"
                :label="$t('stormwatch.map.from')" v-model="from" type="datetime-local" filled dense />

              <v-divider class="py-2" />

              <span>
                Filtre dernière(s) <b>{{ offset }}</b> heure(s)
              </span><br />
              <v-row>
                <v-col cols="3">
                  <v-btn small elevation="0" @click="offset = 1" :color="offset == 1 ? 'primary' : ''">1h</v-btn>
                </v-col>
                <v-col cols="3">
                  <v-btn small elevation="0" @click="offset = 3" :color="offset == 3 ? 'primary' : ''">3h</v-btn>
                </v-col>
                <v-col cols="3">
                  <v-btn small elevation="0" @click="offset = 6" :color="offset == 6 ? 'primary' : ''">6h</v-btn>
                </v-col>
                <v-col cols="3">

                  <v-btn small elevation="0" @click="offset = 24" :color="offset == 24 ? 'primary' : ''">24h</v-btn>

                </v-col>
              </v-row>



              <v-divider class="py-2" />

              <v-row>
                <v-col cols="6">
                  <v-btn small elevation="0" block :color="state.filterPolarity == -1 ? 'primary' : ''"
                    @click="updatePolarity(-1)">{{ $t("stormwatch.map.Polarity") }} -</v-btn>
                </v-col>
                <v-col cols="6">
                  <v-btn small block elevation="0" :color="state.filterPolarity == 1 ? 'primary' : ''"
                    @click="updatePolarity(1)">{{ $t("stormwatch.map.Polarity") }} +</v-btn>
                </v-col>
              </v-row>



              <v-divider class="py-2" />

              <v-row>
                <v-col cols="6">
                  <v-btn small block elevation="0" :color="state.filterType == 0 ? 'primary' : ''"
                    @click="updateType(0)">{{
                      $t("stormwatch.map.CloudGround") }}</v-btn>

                </v-col>
                <v-col cols="6">
                  <v-btn small block elevation="0" :color="state.filterType == 1 ? 'primary' : ''"
                    @click="updateType(1)">{{
                      $t("stormwatch.map.InsideCloud") }}</v-btn>

                </v-col>
              </v-row>



              <template v-if="!from && last_tile">
                <v-switch inset v-model="precipTile" :label="$t('stormwatch.map.PrecipRadar')"  />
              </template>
              <v-divider class="py-2" />
              <v-btn small elevation="0" @click="liveMode = !liveMode" :color="liveMode ? 'red' : ''"><v-icon small
                  :color="liveMode ? 'white' : 'red'">mdi-record</v-icon>
                Live</v-btn>
              <div class="legend my-2"></div>
              <v-row>
                <v-col>
                  <template v-if="from">
                    {{
                      moment(from).subtract(offset, "hours").format("DD/MM HH")
                    }}h
                  </template>
                  <template v-else>
                    {{ moment().subtract(offset, "hours").format("DD/MM HH") }}h
                  </template>
                </v-col>
                <v-col class="text-right">
                  <template v-if="from">
                    {{ moment(from).format("DD/MM HH") }}h
                  </template>
                  <template v-else> {{ moment().format("DD/MM HH") }}h </template>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </LControl>
    </LMap>
    <v-snackbar v-model="goSnackbar" top>
      <span class="green--text">{{ $t("stormwatch.map.NewImpacts") }}...</span>
    </v-snackbar>
    <v-snackbar v-model="noFlashes" top>
      <span class="green--text">Pas d'impacts pour cette periode...</span>
    </v-snackbar>
  </v-col>
</template>
<style>
@import "~leaflet/dist/leaflet.css";
@import "~leaflet-control-geocoder/dist/Control.Geocoder.css";

/* Style pour rendre le marker invisible */
.invisible-marker {
  opacity: 0;
}
</style>
<script>
  /* eslint-disable */
import {
  LMap,
  LTileLayer,
  LGeoJson,
  LRectangle,
  LControl,
  LCircle,
  LMarker,
  LIcon,
  LFeatureGroup,
} from "vue2-leaflet";
import "@/plugins/leaflet-canvas-marker";
import L from "leaflet";
import chroma from "chroma-js";
import axios from "axios";
import moment from "moment-timezone";
import "@ansur/leaflet-pulse-icon";
import "@ansur/leaflet-pulse-icon/dist/L.Icon.Pulse.css";
// import "@/plugins/SmoothZoom";
// import "@/plugins/NoGap";
import _ from "lodash";
import apiStormwatch from "./api-stormwatch";
import api from "../../api";
import { mapState } from "vuex";
import "leaflet.vectorgrid";
import "leaflet-control-geocoder/dist/Control.Geocoder.css";
import "leaflet-control-geocoder";


export default {
  components: {
    LMap,
    LIcon,
    LTileLayer,
    LGeoJson,
    LControl,
    LCircle,
    LMarker,
    LRectangle,
    LFeatureGroup,
  },
  computed: {
    ...mapState(["user", "airport"]),
    center(){
      return this.airport ? [this.airport.latitude, this.airport.longitude] : [47, 2];
    },
    zoom(){
      return this.airport ? 9 : 6;
    },
    maxZoom() {
      if (this.user.features.find(map => map == 'stormwatch') == "stormwatch") {
        console.log("feature ok");
        var maxzoom = 15; 
      } else {
        var maxzoom = 11;
      }
      return maxzoom;
    },
    mapOptions() {
      return {
        minZoom: 5,
        zoomControl: false,
        maxZoom: this.maxZoom,
        preferCanvas: true,
      };
    },
    impactsFiltered() {
      let out = [];
      this.impacts.forEach((impact) => {
        if (
          (this.state.filterPolarity === null ||
            impact.peak * this.state.filterPolarity >= 0) &&
          (this.state.filterType === null ||
            this.state.filterType == impact.type)
        ) {
          out.push(impact);
        }
      });
      return out;
    },
  },
  data: () => ({
    offset: 1,
    isParamOpen: false,
    from: null,
    targetPos: null,
    user_subs: [],
    state: {
      filterPolarity: null,
      filterType: null,
    },
    precipTile: true,
    tracking: false,
    ciLayer: null,
    admin: {
      target: { lat: 47, lon: 2 }
    },
    newimpacts: null,
    loading: true,
    goSnackbar: false,
    lastmarker: null,
    liveMode: true,
    noFlashes: false,
    maxBounds: [
      [41, -7.1],
      [52.2, 10.21],
    ],
    lastimpact: null,
    last_tile: null,
    targetRadius: 0,
    targetColor: null,
    moment: moment,
    impacts: [],
    interval: null,
    legends: [],
    geojsonData: null, 
    userRails:[],
    geoJsonOptions: {
      style: {
        color: '#3388ff',
        weight: 4,
        opacity: 0.8,
      },
    },
  }),
  methods: {
    tooltipImpact(impact) {
      let dtImpact = this.moment(impact.time * 1000);
      
      let typeStr = null;
      if (impact.type == 0) {
        typeStr = this.$t("stormwatch.nuage-sol");
      } else {
        typeStr = this.$t("stormwatch.intra-nuageux");
      }

      let dtStr = dtImpact.format("DD/MM/YY HH:mm:ss");
      let dtStrUTC = dtImpact.utc().format("DD/MM/YY HH:mm:ss");
      let pol = impact.peak < 0 ? "-" : "+";

      let tooltipStr = "<strong>"+typeStr + " (" + pol + ")</strong>";
      tooltipStr += "<br><strong>" + dtStr + " loc.</strong>";
      tooltipStr += "<br>" + dtStrUTC + " UTC";
      tooltipStr +=
        "<br><b>" + this.$t('stormwatch.map.uncertainty') + "</b> " + (impact.ee_major || "500") + "m";
      tooltipStr += "<br><b>max </b>" + Math.round(impact.peak / 1000) + " kA";
      tooltipStr += "<br><b>Lon/Lat </b>" + (Math.round(impact.lon*1000)/1000) + "/" + (Math.round(impact.lat*1000)/1000);

      return tooltipStr;
    },

    updatePolarity(polarity) {
      this.state.filterPolarity =
        this.state.filterPolarity == polarity ? null : polarity;
    },
    changeAdminCursor(e) {
      if (this.user.id_user == 3050 || this.user.id_user == 2520) {
        this.admin.target.lat = e.latlng.lat
        this.admin.target.lon = e.latlng.lng
      }
    },
    updateType(type) {
      this.state.filterType = this.state.filterType == type ? null : type;
    },
    markerColor(time) {
      let nbSteps = this.offset; // TODO dynamic ?
      let colors = chroma
        .scale(["#ed0707", "#f08c22", "#fcfc68", "#40b81c", "#989898"])
        .colors(nbSteps);
      let from = moment();
      if (this.from) {
        from = this.from;
      }
      let partSize =
        (moment(from).unix() -
          moment(from).subtract(this.offset, "hours").unix()) /
        60 /
        nbSteps;
      let idx = Math.floor((moment(from).unix() - time) / partSize / nbSteps);
      return colors[idx];
    },
    async getSubs() {
      this.user_subs = await apiStormwatch.users.getSubs(this.user.id_user);
    },
    async loadUserRails() {
      try {
        this.loading = true;
        const rails = await apiStormwatch.rails.getUserRails(this.user.id_user,this.$store.state.token);
        console.log('Rails utilisateur chargés:', rails);
        
        // Charger les rails avec leurs tronçons
        this.userRails = await Promise.all(rails.map(async (rail) => {
          const railData = {
            id: rail.id_rail,
            name: rail.nom_ligne || `Rail ${rail.id}`,
            defaut: rail.default_rail === 1 ? true : false,
            distance: rail.distance || 0,
            troncons: [],
          };
          
          // Charger les tronçons pour chaque rail
          try {
            const troncons = await apiStormwatch.rails.getRailTroncons(rail.id_rail,this.user.id_user,this.$store.state.token);
            console.log('Tronçons chargés pour le rail:', rail.id_rail, troncons);
            railData.troncons = troncons.map((troncon, index) => {
              console.log("troncon",troncon)
              const parsedGeojson = this.parseGeojson(troncon.geojson || troncon);
              return {
                id: troncon.id || index,
                geojson: parsedGeojson,
                geojson_radius1: troncon.geojson_radius1,
                geojson_radius2: troncon.geojson_radius2,
                geojson_radius3: troncon.geojson_radius3,
              };
            }).filter(troncon => troncon.geojson !== null); // Filtrer les GeoJSON invalides
          } catch (error) {
            console.error(`Erreur lors du chargement des tronçons pour le rail ${rail.id_rail}:`, error);
          }
          
          return railData;
        }));
        
        console.log('Rails utilisateur transformés:', this.userRails);
      } catch (error) {
        console.error('Erreur lors du chargement des rails utilisateur:', error);
        
      } finally {
        this.loading = false;
      }
    },
    parseGeojson(geojson) {
      if (typeof geojson === 'string') {
        try {
          return JSON.parse(geojson);
        } catch (error) {
          console.error('Erreur lors du parsing du GeoJSON:', error);
          return null;
        }
      }
      return geojson;
    },
    async getFlashes(live = null) {
      this.loading = true;
      try {
        let query = "";
        if (this.from) {
          query = `?time=${moment(this.from)
            .subtract(this.offset, "hours")
            .unix()}-${moment(this.from).unix()}`;
        } else {
          query = `?time=${moment()
            .subtract(this.offset, "hours")
            .unix()}-${moment().unix()}`;
        }
        if (live) {
          query = `?time=${moment()
            .subtract(this.offset, "hours")
            .unix()}-${moment().unix()}`;
        }
        let res = await axios.get(
          `https://api.stormwatch.previmeteo.net/entln/flashes${query}`
        );
        if (!res.data) this.noFlashes = true;
        res.data = _.sortBy(res.data, "time");
        if (!this.ciLayer) {
          this.ciLayer = L.canvasIconLayer({}).addTo(this.$refs.map.mapObject);
        } else {
          this.ciLayer.clearLayers();
        }
        var markers = [];
        var marker;
        if (!res.data) res.data = [];
        if (this.lastimpact && res.data[res.data.length - 1]) {
          this.newimpacts =
            this.lastimpact.id != res.data[res.data.length - 1].id
              ? true
              : false;
        }
        this.impacts = res.data;
        this.impacts = this.impactsFiltered;
        this.lastimpact = this.impactsFiltered[this.impactsFiltered.length - 1];
        this.impactsFiltered.forEach((element) => {
          let color = this.markerColor(element.time);
          if (color) {
            color = color.replace("#", "%23");
          } else {
            color = "%23989898";
          }
          var icon = L.icon({
            iconUrl: `https://api.iconify.design/fa-solid/plus.svg?color=${color}&height=16`,
            iconSize: [10, 10],
            iconAnchor: [5, 5],
          });
          marker = L.marker([element.lat, element.lon], {
            icon: icon,
          }).bindPopup(this.tooltipImpact(element));
          marker.data = element;
          markers.push(marker);
        });

        let time = this.impactsFiltered[this.impactsFiltered.length - 1]
          ? this.impactsFiltered[this.impactsFiltered.length - 1].time
          : null;
        let ee_major = this.impactsFiltered[this.impactsFiltered.length - 1]
          ? this.impactsFiltered[this.impactsFiltered.length - 1].ee_major
          : null;

        var pulsingIcon = L.icon.pulse({
          iconSize: [10, 10],
          fillColor: this.markerColor(time),
          color: "#000",
        });
        if (this.lastmarker) {
          this.lastmarker.remove();
        }
        if (this.impactsFiltered[this.impactsFiltered.length - 1]) {
          this.lastmarker = L.marker(
            [
              this.impactsFiltered[this.impactsFiltered.length - 1].lat,
              this.impactsFiltered[this.impactsFiltered.length - 1].lon,
            ],
            {
              icon: pulsingIcon,
            }
          );
          this.lastmarker.bindPopup(
            `${this.tooltipImpact(
              this.impactsFiltered[this.impactsFiltered.length - 1]
            )}`
          );
          this.lastmarker.on("click", (e) => {
            this.targetPos = e.latlng;
            this.targetRadius = ee_major;
            this.targetColor = this.markerColor(time);
          });
          this.lastmarker.addTo(this.$refs.map.mapObject);
          if (this.tracking) {
            this.$refs.map.mapObject.setView(
              [
                this.impactsFiltered[this.impactsFiltered.length - 1].lat,
                this.impactsFiltered[this.impactsFiltered.length - 1].lon,
              ],
              8
            );
          }
          this.ciLayer.addOnClickListener((e, data) => {
            this.targetPos = [data[0].data.data.lat, data[0].data.data.lon];
            this.targetRadius = data[0].data.data.ee_major;
            this.targetColor = this.markerColor(data[0].data.data.time);
          });
          this.ciLayer.addLayers(markers);
        }
      } catch (err) {
        console.log("erreur "+err);
      }
      this.getRainviewerTiles();
      this.loading = false;
      // demarrage LiveMode
      clearInterval(this.interval);
      if (this.liveMode) {
        this.interval = setInterval(() => {
          this.getFlashes(true);
        }, 6000);
      }
    },
    async getRainviewerTiles() {
      
      let snapshot = await api.proxy.rainbowSnapshot();
      console.log("snapshot ",snapshot);
      this.last_tile = `https://api-my.previmeteo.net/proxy/rainbow/precip/${snapshot.snapshot}/0/{z}/{x}/{y}`;
      //console.log(this.last_tile)
    },
    
    async loadGeojson() {
        try {
          const response = await fetch('/layer/departement.geojson');
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          this.geojsonData = await response.json();
          L.geoJSON(this.geojsonData, {
              style: {
                // here define your desired color
                color: 'lightblue',
                fill:false
              }
           }).addTo(this.$refs.map.mapObject);
        } catch (error) {
          console.error('There was a problem with the fetch operation:', error);
        }
      },
      addVectorLayer() {
        const vectorTileOptions = {
          vectorTileLayerStyles: {
            // Définir le style pour les tuiles vectorielles
            default: {
              weight: 1,
              color: '#000000',
              fillColor: '#ffffff',
              fillOpacity: 0.5
            }
          },
          maxNativeZoom: 14, // Niveau de zoom maximal pour les tuiles natives
          url: 'https://communes.vtiles.previmeteo.net/{z}/{x}/{y}.pbf', // URL des tuiles vectorielles .pbf          
        };
      
        this.vectorGridLayer = L.vectorGrid.protobuf(
          vectorTileOptions.url,
          vectorTileOptions
        );
        
        if (this.zoom >= 12) {
          this.vectorGridLayer.addTo(this.$refs.map.mapObject);
        }
      },
      removeVectorLayer() {
        if (this.vectorGridLayer) {
          this.$refs.map.mapObject.removeLayer(this.vectorGridLayer);
        }
      },
      onZoomEnd() {
        const currentZoom = this.$refs.map.mapObject.getZoom();
        console.log("zoom "+currentZoom);
        if (currentZoom >= 12 && !this.$refs.map.mapObject.hasLayer(this.vectorGridLayer)) {
          this.precipTile=false;
          this.vectorGridLayer.addTo(this.$refs.map.mapObject);
        } else if (currentZoom < 12 && this.$refs.map.mapObject.hasLayer(this.vectorGridLayer)) {
          this.precipTile=true;
          this.removeVectorLayer();
        }
      },addGeocoder() {
        const geocoder = L.Control.geocoder({
          defaultMarkGeocode: false
        })
          .on('markgeocode', (e) => {
            const center = e.geocode.center;
            this.$refs.map.mapObject.setView(center, 13); // Centrer la carte sur le résultat avec un zoom de 13
            L.marker(center, { icon: this.customIcon }).addTo(this.$refs.map.mapObject) // Ajouter un marqueur au centre
              .bindPopup(e.geocode.name) // Lier une popup avec le nom du lieu
              .openPopup(); // Ouvrir la popup
          })
          .addTo(this.$refs.map.mapObject);
      }
  },
  mounted() {
    //if (moment().format("H") >= 18 || moment().format("H") <= 7) {
      // this.$vuetify.theme.dark = true;
    //}
    console.log("features",this.token);
    this.getFlashes();
    this.getSubs();
    if (this.user.features.find(map => map == 'stormwatch') == "stormwatch") {
      this.loadGeojson();
      this.addVectorLayer();
      this.addGeocoder();
      if (this.user.features && this.user.features.includes('rail')) {
        this.loadUserRails();
      }
    }
  },
  created() {
    // Définir une icône personnalisée invisible
    this.customIcon = L.divIcon({
      className: 'invisible-marker',
      iconSize: [0, 0]
    });
  },
  watch: {
    from() {
      this.getFlashes();
    },
    state: {
      deep: true,
      handler() {
        this.getFlashes(this.liveMode);
      },
    },
    offset() {
      if(!this.offset > 1 ){
        this.liveMode = false;
      }
      this.getFlashes(this.liveMode);
    },
    liveMode() {
      //console.log('Livemode '+this.liveMode);
      this.getFlashes(this.liveMode);
      this.from = null;
      clearInterval(this.interval);
      if (this.liveMode) {
        this.interval = setInterval(() => {
          this.getFlashes(true);
        }, 6000);
      }
    },
    newimpacts() {
      this.goSnackbar = true;
    },
  },
};
</script>

<style lang="scss" scopped>
.legend {
  background: rgb(159, 159, 159);
  background: linear-gradient(90deg,
      #989898,
      #40b81c,
      #fcfc68,
      #f08c22,
      #ed0707);
  width: 100%;
  height: 10px;
}

.leaflet-bottom.leaflet-left,
.leaflet-bottom.leaflet-control {
  width: 100%;
}


.leaflet-top.leaflet-right {
  top: 4em !important;
}
</style>
